import { render, staticRenderFns } from "./BlocoFiltrosDashboard.vue?vue&type=template&id=0c6a0d3c&scoped=true&lang=pug"
import script from "./BlocoFiltrosDashboard.vue?vue&type=script&lang=js"
export * from "./BlocoFiltrosDashboard.vue?vue&type=script&lang=js"
import style0 from "./BlocoFiltrosDashboard.vue?vue&type=style&index=0&id=0c6a0d3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a0d3c",
  null
  
)

export default component.exports